<div class="row h-100 mx-0 race-prediction actual-page-view">
    <div class="col-lg-12 h-100">
        <div class="card shadow-sm rounded">
            <h4 class="card-title bg-rose">{{raceName}} </h4>
            <div class="card-body">
                <div class="tab-content" id="pills-tabContent" *ngIf="raceEntries.length > 0">
                    <div class="card pb-0 mb-4">
                        <div class="card-body p-0 overflow-hidden">
                            <div class="table-responsive race-prediction-table">
                                <table class="table table-dark border-bottom">
                                    <thead>
                                        <tr>
                                            <th rowspan="2" class="text-center border-left border-right headcol">
                                                Competitors</th>
                                            <th rowspan="2" class="text-center border-left border-right headcol">
                                                Updated By</th>
                                            <th colspan="6" class="text-center border-right bb-0">Drivers</th>
                                            <th colspan="3" class="text-center border-right bb-0">Sprint Entry</th>
                                            <th colspan="3" class="text-center border-right bb-0">Constructors</th>
                                            <th rowspan="2" class="text-center border-right">MPG</th>
                                            <th rowspan="2" class="text-center border-right">FL</th>
                                            <th rowspan="2" class="text-center border-right">PP</th>
                                            <th rowspan="2" class="text-center border-right">Action</th>
                                        </tr>
                                        <tr>
                                            <th class="bt-0">1st</th>
                                            <th class="bt-0">2nd</th>
                                            <th class="bt-0">3rd</th>
                                            <th class="bt-0">4th</th>
                                            <th class="bt-0">5th</th>
                                            <th class="bt-0 border-right">6th</th>
                                            <th class="bt-0">1st</th>
                                            <th class="bt-0">2nd</th>
                                            <th class="bt-0 border-right">3rd</th>
                                            <th class="bt-0">1st</th>
                                            <th class="bt-0">2nd</th>
                                            <th class="bt-0 border-right">3rd</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let raceEntry of raceEntries">
                                            <td class="border-left border-right text-left headcol">
                                                <div>{{raceEntry.userName}}</div>
                                            </td>
                                            <td class="border-left border-right text-left headcol">
                                                <div *ngIf="raceEntry.updatedByAdmin">
                                                    <div>{{raceEntry.updatedByAdmin}}</div>
                                                    <div>{{raceEntry.updatedOnUI | date: 'dd/MM/yyyy - HH:mm'}}</div>
                                                </div>
                                                <div *ngIf="!raceEntry.updatedByAdmin">-</div>
                                            </td>

                                            <!-- Drivers -->
                                            <ng-container *ngFor="let i of [0,1,2,3,4,5]">
                                                <td *ngIf="raceEntry.raceEntryDriverTRX[i]">
                                                    <ng-template #popDriver>
                                                        <div class="user-name-pic">
                                                            <span class="user-pic">
                                                                <img [src]="raceEntry.raceEntryDriverTRX[i].drivers.driverPic"
                                                                    class="img-fluid" />
                                                            </span>
                                                            {{raceEntry.raceEntryDriverTRX[i].drivers.foreName + ' ' +
                                                            raceEntry.raceEntryDriverTRX[i].drivers.surName}}
                                                        </div>
                                                    </ng-template>
                                                    <div class="text-ellipsis" [ngbPopover]="popDriver" placement="top"
                                                        triggers="mouseenter:mouseleave">
                                                        {{raceEntry.raceEntryDriverTRX[i].drivers.foreName}}
                                                    </div>
                                                </td>
                                                <td *ngIf="!raceEntry.raceEntryDriverTRX[i]" class="center">-</td>
                                            </ng-container>

                                            <!-- Sprint Entry -->
                                            <ng-container *ngFor="let i of [0,1,2]">
                                                <td
                                                    *ngIf="raceEntry.raceEntrySprintTrx && raceEntry.raceEntrySprintTrx[i]">
                                                    <ng-template #popSprint>
                                                        <div class="user-name-pic">
                                                            <span class="user-pic">
                                                                <img [src]="raceEntry.raceEntrySprintTrx[i].drivers.driverPic"
                                                                    class="img-fluid" />
                                                            </span>
                                                            {{raceEntry.raceEntrySprintTrx[i].drivers.foreName + ' ' +
                                                            raceEntry.raceEntrySprintTrx[i].drivers.surName}}
                                                        </div>
                                                    </ng-template>
                                                    <div class="text-ellipsis" [ngbPopover]="popSprint" placement="top"
                                                        triggers="mouseenter:mouseleave">
                                                        {{raceEntry.raceEntrySprintTrx[i].drivers.foreName}}
                                                    </div>
                                                </td>
                                                <td *ngIf="!raceEntry.raceEntrySprintTrx || !raceEntry.raceEntrySprintTrx[i]"
                                                    class="center">-</td>
                                            </ng-container>

                                            <!-- Constructors -->
                                            <ng-container *ngFor="let i of [0,1,2]">
                                                <td *ngIf="raceEntry.raceEntryConstructorTRX[i]">
                                                    <ng-template #popConstr>
                                                        <div class="user-name-pic">
                                                            <span class="user-pic">
                                                                <img [src]="raceEntry.raceEntryConstructorTRX[i].constructors.constructorPic"
                                                                    class="img-fluid" />
                                                            </span>
                                                            {{raceEntry.raceEntryConstructorTRX[i].constructors.name}}
                                                        </div>
                                                    </ng-template>
                                                    <div class="text-ellipsis" [ngbPopover]="popConstr" placement="top"
                                                        triggers="mouseenter:mouseleave">
                                                        {{raceEntry.raceEntryConstructorTRX[i].constructors.name}}
                                                    </div>
                                                </td>
                                                <td *ngIf="!raceEntry.raceEntryConstructorTRX[i]" class="center">-</td>
                                            </ng-container>

                                            <!-- MPG, FL, PP -->
                                            <td class="border-right text-center">
                                                <ng-container *ngIf="raceEntry.raceEntryLapDetail; else noMpg">
                                                    <ng-template #popMpg>
                                                        <div class="user-name-pic">
                                                            <span class="user-pic">
                                                                <img [src]="raceEntry.raceEntryLapDetail.mostPlacesGainedDriver.driverPic"
                                                                    class="img-fluid" />
                                                            </span>
                                                            {{raceEntry.raceEntryLapDetail.mostPlacesGainedDriver.foreName
                                                            + ' ' +
                                                            raceEntry.raceEntryLapDetail.mostPlacesGainedDriver.surName}}
                                                        </div>
                                                    </ng-template>
                                                    <div class="text-ellipsis" [ngbPopover]="popMpg" placement="left"
                                                        triggers="mouseenter:mouseleave">
                                                        {{raceEntry.raceEntryLapDetail.mostPlacesGainedDriver.foreName}}
                                                    </div>
                                                </ng-container>
                                                <ng-template #noMpg>-</ng-template>
                                            </td>
                                            <td class="border-right text-center">
                                                <ng-container *ngIf="raceEntry.raceEntryLapDetail; else noFl">
                                                    <ng-template #popFl>
                                                        <div class="user-name-pic">
                                                            <span class="user-pic">
                                                                <img [src]="raceEntry.raceEntryLapDetail.fastestLapDriver.driverPic"
                                                                    class="img-fluid" />
                                                            </span>
                                                            {{raceEntry.raceEntryLapDetail.fastestLapDriver.foreName + '
                                                            ' +
                                                            raceEntry.raceEntryLapDetail.fastestLapDriver.surName }}
                                                        </div>
                                                    </ng-template>
                                                    <div class="text-ellipsis" [ngbPopover]="popFl" placement="left"
                                                        triggers="mouseenter:mouseleave">
                                                        {{raceEntry.raceEntryLapDetail.fastestLapDriver.foreName}}
                                                    </div>
                                                </ng-container>
                                                <ng-template #noFl>-</ng-template>
                                            </td>
                                            <td class="border-right text-center">
                                                <ng-container *ngIf="raceEntry.raceEntryLapDetail; else noPp">
                                                    <ng-template #popPp>
                                                        <div class="user-name-pic">
                                                            <span class="user-pic">
                                                                <img [src]="raceEntry.raceEntryLapDetail.polePositionDriver.driverPic"
                                                                    class="img-fluid" />
                                                            </span>
                                                            {{raceEntry.raceEntryLapDetail.polePositionDriver.foreName +
                                                            ' '
                                                            + raceEntry.raceEntryLapDetail.polePositionDriver.surName}}
                                                        </div>
                                                    </ng-template>
                                                    <div class="text-ellipsis" [ngbPopover]="popPp" placement="left"
                                                        triggers="mouseenter:mouseleave">
                                                        {{raceEntry.raceEntryLapDetail.polePositionDriver.foreName}}
                                                    </div>
                                                </ng-container>
                                                <ng-template #noPp>-</ng-template>
                                            </td>
                                            <td class="text-center">
                                                <button class="btn" (click)="editPrediction(raceEntry)"
                                                    title="Edit Prediction">
                                                    <i class="fa fa-edit"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center py-5" *ngIf="raceEntries.length === 0 && !PreLoader">
                    <span>No predictions found for this race.</span>
                </div>
                <div class="box-loader" *ngIf="PreLoader">
                    <img src="assets/img/progress.svg" alt="Progress">
                </div>
            </div>
        </div>
    </div>
</div>